export const uk = {
  slug: "uk",
  name: "United Kingdom",
  flag: "🇬🇧",
  tagline: "World-Class Degrees in Just 1–3 Years",
  heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
  accentColor: "#C0392B",
  students: "280+",
  avgTuition: "£14,000–£30,000/yr",
  avgLiving: "£1,000–£1,500/mo",
  workPermit: "2 years post-study (Graduate Route)",
  ieltsReq: "6.0–7.5",
  intakeMonths: ["September (Main)", "January (Limited)"],
  overview:
    "The UK is home to 4 of the world's top 10 universities, offers 1-year master's programmes (saving you a full year of costs), and the Graduate Route visa gives 2 years to work freely post-study. A fast, prestigious route to global careers.",
  whyChoose: [
    { icon: "⚡", title: "1-Year Master's", desc: "Complete a full master's in 12 months vs 2 years in US/Australia — faster ROI on your investment." },
    { icon: "🏛️", title: "Prestigious Institutions", desc: "Oxford, Cambridge, Imperial, UCL, Edinburgh — globally recognised names that open every door." },
    { icon: "🌍", title: "Graduate Route Visa", desc: "2 years (3 for PhD) to work in any job, anywhere in the UK — no employer sponsorship needed." },
    { icon: "💼", title: "Strong Alumni Networks", desc: "UK universities have the densest professional alumni networks in Europe and globally." },
    { icon: "📚", title: "Research Excellence", desc: "The UK produces 14% of the world's most-cited research with just 1% of global population." },
    { icon: "🗣️", title: "English Native Environment", desc: "Full English immersion — ideal for building professional-grade fluency and global confidence." },
  ],
  process: [
    { step: "01", title: "University Shortlisting", desc: "We match your profile to Russell Group and other top-ranked universities based on IELTS, grades, and budget." },
    { step: "02", title: "UCAS / Direct Application", desc: "Personal statements, CVs, reference letters — crafted to UK admission standards." },
    { step: "03", title: "CAS & Student Visa", desc: "Once accepted, your CAS number unlocks the Tier 4 Student Visa application — we manage every form." },
    { step: "04", title: "Pre-Departure Prep", desc: "Accommodation shortlisting, travel booking, NHS surcharge, and UK arrival orientation." },
  ],
  universities: [
    "university-of-edinburgh", "university-of-manchester", "queen-mary-london", "university-of-glasgow",
    "imperial-college-london", "ucl", "kings-college-london", "lse",
    "university-of-warwick", "university-of-bristol", "university-of-leeds", "university-of-sheffield",
    "university-of-nottingham", "university-of-birmingham", "university-of-southampton", "university-of-exeter",
    "university-of-bath", "university-of-durham", "university-of-york", "university-of-reading",
    "university-of-leicester", "university-of-surrey", "brunel-university", "city-university-london",
    "university-of-portsmouth",
  ],
  stats: [
    { n: "280+", label: "Students Placed" },
    { n: "1yr",  label: "Master's Duration" },
    { n: "98%",  label: "Visa Success" },
    { n: "2yr",  label: "Graduate Route" },
  ],
};
